module.exports = __webpack_public_path__ + "media/images/common/sns/youtube-0821fec7067d6509efb65bd95320b9fb.png";